/* eslint-disable @typescript-eslint/unified-signatures */

/**Generated by orval v1.0.0 🍺
Do not edit manually.
Starlink Dev Admin REST API
Dev/test-only endpoints for Twisp time server, jobs, and admin utilities.
*/
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';

import { useCustomClient } from '../../dev-api/dev-client';
import type { ErrorType, BodyType } from '../../dev-api/dev-client';

export type RepaymentBouncedOutcomeKind =
  (typeof RepaymentBouncedOutcomeKind)[keyof typeof RepaymentBouncedOutcomeKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepaymentBouncedOutcomeKind = {
  BOUNCED: 'BOUNCED',
} as const;

export interface RepaymentBouncedOutcome {
  code: string;
  kind: RepaymentBouncedOutcomeKind;
  on: string;
  resolution?: RepaymentBounceResolution;
}

export interface ErrorResponse {
  error: string;
}

export type RepaymentActionAllOfKind = (typeof RepaymentActionAllOfKind)[keyof typeof RepaymentActionAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepaymentActionAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type RepaymentActionAllOf = {
  date: string;
  kind: RepaymentActionAllOfKind;
};

export type RepaymentActionAllOfThree = {
  outcome: RepaymentOutcome;
  plaidAccountId?: string;
  repaymentAmountCents: number;
};

export type RepaymentActionKind = (typeof RepaymentActionKind)[keyof typeof RepaymentActionKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepaymentActionKind = {
  REPAYMENT: 'REPAYMENT',
} as const;

export type RepaymentAction = RepaymentActionAllOf &
  RepaymentActionAllOfThree & {
    kind: RepaymentActionKind;
  };

/**
 * @nullable
 */
export type AddCardTransactionRequestJson = { [key: string]: unknown } | null;

export interface AddCardTransactionRequest {
  amountCents?: number;
  cardId?: string;
  cardRef?: string;
  /** @nullable */
  effectiveDate?: string | null;
  /** @nullable */
  json: AddCardTransactionRequestJson;
  loanId: string;
  /** @nullable */
  merchantName?: string | null;
  /** @nullable */
  originalStan?: string | null;
  /** @nullable */
  stan?: string | null;
  transactionType: string;
}

export type UpdateJobRequestUpdatesArgs = { [key: string]: unknown };

export type UpdateJobRequestUpdatesMeta = { [key: string]: unknown };

export type UpdateJobRequestUpdatesState =
  (typeof UpdateJobRequestUpdatesState)[keyof typeof UpdateJobRequestUpdatesState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateJobRequestUpdatesState = {
  available: 'available',
  executing: 'executing',
  retryable: 'retryable',
  scheduled: 'scheduled',
  completed: 'completed',
  cancelled: 'cancelled',
  discarded: 'discarded',
} as const;

export type UpdateJobRequestUpdates = {
  args?: UpdateJobRequestUpdatesArgs;
  /** @minimum 0 */
  attempt?: number;
  /** @nullable */
  attemptedAt?: string | null;
  /** @nullable */
  cancelledAt?: string | null;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  discardedAt?: string | null;
  /** @minimum 0 */
  maxAttempts?: number;
  meta?: UpdateJobRequestUpdatesMeta;
  /** @minimum 0 */
  priority?: number;
  queue?: string;
  /** @nullable */
  scheduledAt?: string | null;
  state?: UpdateJobRequestUpdatesState;
  tags?: string[];
  worker?: string;
};

export interface UpdateJobRequest {
  updates: UpdateJobRequestUpdates;
}

export type TimelineActionOneOfAllOfKind =
  (typeof TimelineActionOneOfAllOfKind)[keyof typeof TimelineActionOneOfAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimelineActionOneOfAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type TimelineActionOneOfAllOf = {
  date: string;
  kind: TimelineActionOneOfAllOfKind;
};

export type TimelineActionOneOfAllOfThree = {
  amountCents: number;
  lastFour?: string;
  merchantName?: string;
};

export type TimelineActionOneOf = TimelineActionOneOfAllOf & TimelineActionOneOfAllOfThree;

export type TimelineActionOneOfFiveAllOfKind =
  (typeof TimelineActionOneOfFiveAllOfKind)[keyof typeof TimelineActionOneOfFiveAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimelineActionOneOfFiveAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type TimelineActionOneOfFiveAllOf = {
  date: string;
  kind: TimelineActionOneOfFiveAllOfKind;
};

export type TimelineActionOneOfFiveAllOfThree = {
  outcome: RepaymentOutcome;
  plaidAccountId?: string;
  repaymentAmountCents: number;
};

export type TimelineActionOneOfFive = TimelineActionOneOfFiveAllOf & TimelineActionOneOfFiveAllOfThree;

export type TimelineActionOneOfNineAllOfKind =
  (typeof TimelineActionOneOfNineAllOfKind)[keyof typeof TimelineActionOneOfNineAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimelineActionOneOfNineAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type TimelineActionOneOfNineAllOf = {
  date: string;
  kind: TimelineActionOneOfNineAllOfKind;
};

export type TimelineActionOneOfNineAllOfThree = {
  feeAmountCents: number;
  feeDescription?: string;
  feeType?: string;
};

export type TimelineActionOneOfNine = TimelineActionOneOfNineAllOf & TimelineActionOneOfNineAllOfThree;

export type TimelineActionOneOfOnethreeAllOfKind =
  (typeof TimelineActionOneOfOnethreeAllOfKind)[keyof typeof TimelineActionOneOfOnethreeAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimelineActionOneOfOnethreeAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type TimelineActionOneOfOnethreeAllOf = {
  date: string;
  kind: TimelineActionOneOfOnethreeAllOfKind;
};

export type TimelineActionOneOfOnethreeAllOfThree = {
  generatePdf?: boolean;
  periodFrom: string;
  periodTo: string;
};

export type TimelineActionOneOfOnethree = TimelineActionOneOfOnethreeAllOf & TimelineActionOneOfOnethreeAllOfThree;

export type TimelineActionOneOfOnesevenAllOfKind =
  (typeof TimelineActionOneOfOnesevenAllOfKind)[keyof typeof TimelineActionOneOfOnesevenAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimelineActionOneOfOnesevenAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type TimelineActionOneOfOnesevenAllOf = {
  date: string;
  kind: TimelineActionOneOfOnesevenAllOfKind;
};

export type TimelineActionOneOfOnesevenAllOfThree = {
  adbCents?: number;
  statementId?: string;
};

export type TimelineActionOneOfOneseven = TimelineActionOneOfOnesevenAllOf & TimelineActionOneOfOnesevenAllOfThree;

export type TimelineActionOneOfTwooneAllOfKind =
  (typeof TimelineActionOneOfTwooneAllOfKind)[keyof typeof TimelineActionOneOfTwooneAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimelineActionOneOfTwooneAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type TimelineActionOneOfTwooneAllOf = {
  date: string;
  kind: TimelineActionOneOfTwooneAllOfKind;
};

export type TimelineActionOneOfTwooneAllOfThree = {
  drawdownAmountCents: number;
  plaidAccountId?: string;
};

export type TimelineActionOneOfTwoone = TimelineActionOneOfTwooneAllOf & TimelineActionOneOfTwooneAllOfThree;

export type TimelineActionOneOfTwofiveAllOfKind =
  (typeof TimelineActionOneOfTwofiveAllOfKind)[keyof typeof TimelineActionOneOfTwofiveAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimelineActionOneOfTwofiveAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type TimelineActionOneOfTwofiveAllOf = {
  date: string;
  kind: TimelineActionOneOfTwofiveAllOfKind;
};

export type TimelineActionOneOfTwosevenAllOfKind =
  (typeof TimelineActionOneOfTwosevenAllOfKind)[keyof typeof TimelineActionOneOfTwosevenAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimelineActionOneOfTwosevenAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type TimelineActionOneOfTwosevenAllOf = {
  date: string;
  kind: TimelineActionOneOfTwosevenAllOfKind;
};

export type TimelineActionOneOfTwosevenAllOfThree = {
  returnCode?: string;
};

export type TimelineActionOneOfTwoseven = TimelineActionOneOfTwosevenAllOf & TimelineActionOneOfTwosevenAllOfThree;

export type TimelineAction =
  | TimelineActionOneOf
  | TimelineActionOneOfFive
  | TimelineActionOneOfNine
  | TimelineActionOneOfOnethree
  | TimelineActionOneOfOneseven
  | TimelineActionOneOfTwoone
  | TimelineActionOneOfTwofiveAllOf
  | TimelineActionOneOfTwoseven;

export interface ProgramTwispResources {
  exposureAccountSet: ProgramTwispResourceResult;
  isoConfig: ProgramTwispResourceResult;
  journal: ProgramTwispResourceResult;
}

export type RepaymentBounceResolutionKind =
  (typeof RepaymentBounceResolutionKind)[keyof typeof RepaymentBounceResolutionKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepaymentBounceResolutionKind = {
  CANCELLED: 'CANCELLED',
  RETURNED: 'RETURNED',
} as const;

export interface RepaymentBounceResolution {
  code?: string;
  kind: RepaymentBounceResolutionKind;
  on: string;
}

export interface RunTimelineResponse {
  jobId: string;
  message: string;
}

export interface ProgramTwispRestoreResponse {
  programId: string;
  resources: ProgramTwispResources;
}

export type DrawdownActionAllOfKind = (typeof DrawdownActionAllOfKind)[keyof typeof DrawdownActionAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DrawdownActionAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type DrawdownActionAllOf = {
  date: string;
  kind: DrawdownActionAllOfKind;
};

export type DrawdownActionAllOfThree = {
  drawdownAmountCents: number;
  plaidAccountId?: string;
};

export type DrawdownActionKind = (typeof DrawdownActionKind)[keyof typeof DrawdownActionKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DrawdownActionKind = {
  DRAWDOWN: 'DRAWDOWN',
} as const;

export type DrawdownAction = DrawdownActionAllOf &
  DrawdownActionAllOfThree & {
    kind: DrawdownActionKind;
  };

export type ProcessLateFeeActionAllOfKind =
  (typeof ProcessLateFeeActionAllOfKind)[keyof typeof ProcessLateFeeActionAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessLateFeeActionAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type ProcessLateFeeActionAllOf = {
  date: string;
  kind: ProcessLateFeeActionAllOfKind;
};

export type ProcessLateFeeActionKind = (typeof ProcessLateFeeActionKind)[keyof typeof ProcessLateFeeActionKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessLateFeeActionKind = {
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
} as const;

export type ProcessLateFeeAction = ProcessLateFeeActionAllOf & {
  kind: ProcessLateFeeActionKind;
};

export type CardPurchaseActionAllOfKind =
  (typeof CardPurchaseActionAllOfKind)[keyof typeof CardPurchaseActionAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardPurchaseActionAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type CardPurchaseActionAllOf = {
  date: string;
  kind: CardPurchaseActionAllOfKind;
};

export type CardPurchaseActionAllOfThree = {
  amountCents: number;
  lastFour?: string;
  merchantName?: string;
};

export type CardPurchaseActionKind = (typeof CardPurchaseActionKind)[keyof typeof CardPurchaseActionKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardPurchaseActionKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
} as const;

export type CardPurchaseAction = CardPurchaseActionAllOf &
  CardPurchaseActionAllOfThree & {
    kind: CardPurchaseActionKind;
  };

export interface InitializeTwispUserRequest {
  userId: string;
}

export type RunTimelineRequestInputActionsItemOneOfAllOfKind =
  (typeof RunTimelineRequestInputActionsItemOneOfAllOfKind)[keyof typeof RunTimelineRequestInputActionsItemOneOfAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunTimelineRequestInputActionsItemOneOfAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type RunTimelineRequestInputActionsItemOneOfAllOf = {
  date: string;
  kind: RunTimelineRequestInputActionsItemOneOfAllOfKind;
};

export type RunTimelineRequestInputActionsItemOneOfAllOfThree = {
  amountCents: number;
  lastFour?: string;
  merchantName?: string;
};

export type RunTimelineRequestInputActionsItemOneOf = RunTimelineRequestInputActionsItemOneOfAllOf &
  RunTimelineRequestInputActionsItemOneOfAllOfThree;

export type RunTimelineRequestInputActionsItemOneOfFiveAllOfKind =
  (typeof RunTimelineRequestInputActionsItemOneOfFiveAllOfKind)[keyof typeof RunTimelineRequestInputActionsItemOneOfFiveAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunTimelineRequestInputActionsItemOneOfFiveAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type RunTimelineRequestInputActionsItemOneOfFiveAllOf = {
  date: string;
  kind: RunTimelineRequestInputActionsItemOneOfFiveAllOfKind;
};

export type RunTimelineRequestInputActionsItemOneOfFiveAllOfThree = {
  outcome: RepaymentOutcome;
  plaidAccountId?: string;
  repaymentAmountCents: number;
};

export type RunTimelineRequestInputActionsItemOneOfFive = RunTimelineRequestInputActionsItemOneOfFiveAllOf &
  RunTimelineRequestInputActionsItemOneOfFiveAllOfThree;

export type RunTimelineRequestInputActionsItemOneOfNineAllOfKind =
  (typeof RunTimelineRequestInputActionsItemOneOfNineAllOfKind)[keyof typeof RunTimelineRequestInputActionsItemOneOfNineAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunTimelineRequestInputActionsItemOneOfNineAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type RunTimelineRequestInputActionsItemOneOfNineAllOf = {
  date: string;
  kind: RunTimelineRequestInputActionsItemOneOfNineAllOfKind;
};

export type RunTimelineRequestInputActionsItemOneOfNineAllOfThree = {
  feeAmountCents: number;
  feeDescription?: string;
  feeType?: string;
};

export type RunTimelineRequestInputActionsItemOneOfNine = RunTimelineRequestInputActionsItemOneOfNineAllOf &
  RunTimelineRequestInputActionsItemOneOfNineAllOfThree;

export type RunTimelineRequestInputActionsItemOneOfOnethreeAllOfKind =
  (typeof RunTimelineRequestInputActionsItemOneOfOnethreeAllOfKind)[keyof typeof RunTimelineRequestInputActionsItemOneOfOnethreeAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunTimelineRequestInputActionsItemOneOfOnethreeAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type RunTimelineRequestInputActionsItemOneOfOnethreeAllOf = {
  date: string;
  kind: RunTimelineRequestInputActionsItemOneOfOnethreeAllOfKind;
};

export type RunTimelineRequestInputActionsItemOneOfOnethreeAllOfThree = {
  generatePdf?: boolean;
  periodFrom: string;
  periodTo: string;
};

export type RunTimelineRequestInputActionsItemOneOfOnethree = RunTimelineRequestInputActionsItemOneOfOnethreeAllOf &
  RunTimelineRequestInputActionsItemOneOfOnethreeAllOfThree;

export type RunTimelineRequestInputActionsItemOneOfOnesevenAllOfKind =
  (typeof RunTimelineRequestInputActionsItemOneOfOnesevenAllOfKind)[keyof typeof RunTimelineRequestInputActionsItemOneOfOnesevenAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunTimelineRequestInputActionsItemOneOfOnesevenAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type RunTimelineRequestInputActionsItemOneOfOnesevenAllOf = {
  date: string;
  kind: RunTimelineRequestInputActionsItemOneOfOnesevenAllOfKind;
};

export type RunTimelineRequestInputActionsItemOneOfOnesevenAllOfThree = {
  adbCents?: number;
  statementId?: string;
};

export type RunTimelineRequestInputActionsItemOneOfOneseven = RunTimelineRequestInputActionsItemOneOfOnesevenAllOf &
  RunTimelineRequestInputActionsItemOneOfOnesevenAllOfThree;

export type RunTimelineRequestInputActionsItemOneOfTwooneAllOfKind =
  (typeof RunTimelineRequestInputActionsItemOneOfTwooneAllOfKind)[keyof typeof RunTimelineRequestInputActionsItemOneOfTwooneAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunTimelineRequestInputActionsItemOneOfTwooneAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type RunTimelineRequestInputActionsItemOneOfTwooneAllOf = {
  date: string;
  kind: RunTimelineRequestInputActionsItemOneOfTwooneAllOfKind;
};

export type RunTimelineRequestInputActionsItemOneOfTwooneAllOfThree = {
  drawdownAmountCents: number;
  plaidAccountId?: string;
};

export type RunTimelineRequestInputActionsItemOneOfTwoone = RunTimelineRequestInputActionsItemOneOfTwooneAllOf &
  RunTimelineRequestInputActionsItemOneOfTwooneAllOfThree;

export type RunTimelineRequestInputActionsItemOneOfTwofiveAllOfKind =
  (typeof RunTimelineRequestInputActionsItemOneOfTwofiveAllOfKind)[keyof typeof RunTimelineRequestInputActionsItemOneOfTwofiveAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunTimelineRequestInputActionsItemOneOfTwofiveAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type RunTimelineRequestInputActionsItemOneOfTwofiveAllOf = {
  date: string;
  kind: RunTimelineRequestInputActionsItemOneOfTwofiveAllOfKind;
};

export type RunTimelineRequestInputActionsItemOneOfTwosevenAllOfKind =
  (typeof RunTimelineRequestInputActionsItemOneOfTwosevenAllOfKind)[keyof typeof RunTimelineRequestInputActionsItemOneOfTwosevenAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunTimelineRequestInputActionsItemOneOfTwosevenAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type RunTimelineRequestInputActionsItemOneOfTwosevenAllOf = {
  date: string;
  kind: RunTimelineRequestInputActionsItemOneOfTwosevenAllOfKind;
};

export type RunTimelineRequestInputActionsItemOneOfTwosevenAllOfThree = {
  returnCode?: string;
};

export type RunTimelineRequestInputActionsItemOneOfTwoseven = RunTimelineRequestInputActionsItemOneOfTwosevenAllOf &
  RunTimelineRequestInputActionsItemOneOfTwosevenAllOfThree;

export type RunTimelineRequestInputActionsItem =
  | RunTimelineRequestInputActionsItemOneOf
  | RunTimelineRequestInputActionsItemOneOfFive
  | RunTimelineRequestInputActionsItemOneOfNine
  | RunTimelineRequestInputActionsItemOneOfOnethree
  | RunTimelineRequestInputActionsItemOneOfOneseven
  | RunTimelineRequestInputActionsItemOneOfTwoone
  | RunTimelineRequestInputActionsItemOneOfTwofiveAllOf
  | RunTimelineRequestInputActionsItemOneOfTwoseven;

export type RunTimelineRequestInput = unknown & {
  actions?: RunTimelineRequestInputActionsItem[];
  loanId?: string;
};

export interface RunTimelineRequest {
  input: RunTimelineRequestInput;
}

export type AchReturnActionAllOfKind = (typeof AchReturnActionAllOfKind)[keyof typeof AchReturnActionAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AchReturnActionAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type AchReturnActionAllOf = {
  date: string;
  kind: AchReturnActionAllOfKind;
};

export type AchReturnActionAllOfThree = {
  returnCode?: string;
};

export type AchReturnActionKind = (typeof AchReturnActionKind)[keyof typeof AchReturnActionKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AchReturnActionKind = {
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type AchReturnAction = AchReturnActionAllOf &
  AchReturnActionAllOfThree & {
    kind: AchReturnActionKind;
  };

export type RepaymentSettledOutcomeKind =
  (typeof RepaymentSettledOutcomeKind)[keyof typeof RepaymentSettledOutcomeKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepaymentSettledOutcomeKind = {
  SETTLED: 'SETTLED',
} as const;

export interface RepaymentSettledOutcome {
  kind: RepaymentSettledOutcomeKind;
  on: string;
}

export type RepaymentReturnedOutcomeKind =
  (typeof RepaymentReturnedOutcomeKind)[keyof typeof RepaymentReturnedOutcomeKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepaymentReturnedOutcomeKind = {
  RETURNED: 'RETURNED',
} as const;

export interface RepaymentReturnedOutcome {
  code: string;
  kind: RepaymentReturnedOutcomeKind;
  on: string;
  settledOn?: string;
}

export interface DisburseFundsResponse {
  amountCents: number;
  id: string;
  loanId: string;
  plaidAccountId: string;
  status: string;
}

export type ProcessDueDateActionAllOfKind =
  (typeof ProcessDueDateActionAllOfKind)[keyof typeof ProcessDueDateActionAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessDueDateActionAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type ProcessDueDateActionAllOf = {
  date: string;
  kind: ProcessDueDateActionAllOfKind;
};

export type ProcessDueDateActionAllOfThree = {
  adbCents?: number;
  statementId?: string;
};

export type ProcessDueDateActionKind = (typeof ProcessDueDateActionKind)[keyof typeof ProcessDueDateActionKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessDueDateActionKind = {
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
} as const;

export type ProcessDueDateAction = ProcessDueDateActionAllOf &
  ProcessDueDateActionAllOfThree & {
    kind: ProcessDueDateActionKind;
  };

export type CloseCycleActionAllOfKind = (typeof CloseCycleActionAllOfKind)[keyof typeof CloseCycleActionAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CloseCycleActionAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type CloseCycleActionAllOf = {
  date: string;
  kind: CloseCycleActionAllOfKind;
};

export type CloseCycleActionAllOfThree = {
  generatePdf?: boolean;
  periodFrom: string;
  periodTo: string;
};

export type CloseCycleActionKind = (typeof CloseCycleActionKind)[keyof typeof CloseCycleActionKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CloseCycleActionKind = {
  CLOSE_CYCLE: 'CLOSE_CYCLE',
} as const;

export type CloseCycleAction = CloseCycleActionAllOf &
  CloseCycleActionAllOfThree & {
    kind: CloseCycleActionKind;
  };

export interface DisburseFundsRequest {
  amountCents: number;
  loanId: string;
  plaidAccountId: string;
}

export interface PayStatementResponse {
  amountCents: number;
  id: string;
  loanId: string;
  plaidAccountId: string;
  status: string;
}

export interface InitializeTwispUserResponse {
  message: string;
  success: boolean;
  userId: string;
}

export interface AddCardTransactionResponse {
  amountCents?: string;
  approvalCode?: string;
  cardReference?: string;
  entryDirection?: string;
  entryId?: string;
  entryLayer?: string;
  entryType?: string;
  merchantName?: string;
  message: string;
  responseCode?: string;
  responseStatus?: string;
  success: boolean;
  transactionId?: string;
  transactionType: string;
}

/**
 * @nullable
 */
export type RecentJobsResponseJobsItemArgs = { [key: string]: unknown } | null;

export type RecentJobsResponseJobsItemState =
  (typeof RecentJobsResponseJobsItemState)[keyof typeof RecentJobsResponseJobsItemState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecentJobsResponseJobsItemState = {
  available: 'available',
  executing: 'executing',
  completed: 'completed',
  retryable: 'retryable',
  discarded: 'discarded',
  cancelled: 'cancelled',
} as const;

export type RecentJobsResponseJobsItem = {
  /** @nullable */
  args?: RecentJobsResponseJobsItemArgs;
  attempt: number;
  /** @nullable */
  attemptedAt: string | null;
  attempts: number;
  /** @nullable */
  cancelledAt?: string | null;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  discardedAt?: string | null;
  errors: string[];
  id: number;
  insertedAt: string;
  queue: string;
  /** @nullable */
  scheduledAt: string | null;
  state: RecentJobsResponseJobsItemState;
  /** @nullable */
  worker?: string | null;
};

export interface RecentJobsResponse {
  count: number;
  jobs: RecentJobsResponseJobsItem[];
}

export interface PayStatementRequest {
  amountCents: number;
  loanId: string;
  plaidAccountId: string;
}

export type RepaymentOutcomeOneOfKind = (typeof RepaymentOutcomeOneOfKind)[keyof typeof RepaymentOutcomeOneOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepaymentOutcomeOneOfKind = {
  SETTLED: 'SETTLED',
} as const;

export type RepaymentOutcomeOneOf = {
  kind: RepaymentOutcomeOneOfKind;
  on: string;
};

export type RepaymentOutcomeOneOfThreeKind =
  (typeof RepaymentOutcomeOneOfThreeKind)[keyof typeof RepaymentOutcomeOneOfThreeKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepaymentOutcomeOneOfThreeKind = {
  RETURNED: 'RETURNED',
} as const;

export type RepaymentOutcomeOneOfThree = {
  code: string;
  kind: RepaymentOutcomeOneOfThreeKind;
  on: string;
  settledOn?: string;
};

export type RepaymentOutcomeOneOfFiveKind =
  (typeof RepaymentOutcomeOneOfFiveKind)[keyof typeof RepaymentOutcomeOneOfFiveKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepaymentOutcomeOneOfFiveKind = {
  BOUNCED: 'BOUNCED',
} as const;

export type RepaymentOutcomeOneOfFive = {
  code: string;
  kind: RepaymentOutcomeOneOfFiveKind;
  on: string;
  resolution?: RepaymentBounceResolution;
};

export type RepaymentOutcomeOneOfSevenKind =
  (typeof RepaymentOutcomeOneOfSevenKind)[keyof typeof RepaymentOutcomeOneOfSevenKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepaymentOutcomeOneOfSevenKind = {
  PENDING: 'PENDING',
} as const;

export type RepaymentOutcomeOneOfSeven = {
  kind: RepaymentOutcomeOneOfSevenKind;
};

export type RepaymentOutcome =
  | RepaymentOutcomeOneOf
  | RepaymentOutcomeOneOfThree
  | RepaymentOutcomeOneOfFive
  | RepaymentOutcomeOneOfSeven;

export type RepaymentPendingOutcomeKind =
  (typeof RepaymentPendingOutcomeKind)[keyof typeof RepaymentPendingOutcomeKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepaymentPendingOutcomeKind = {
  PENDING: 'PENDING',
} as const;

export interface RepaymentPendingOutcome {
  kind: RepaymentPendingOutcomeKind;
}

export type TimelineActionBaseKind = (typeof TimelineActionBaseKind)[keyof typeof TimelineActionBaseKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimelineActionBaseKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export interface TimelineActionBase {
  date: string;
  kind: TimelineActionBaseKind;
}

/**
 * @nullable
 */
export type JobStatusResponseArgs = { [key: string]: unknown } | null;

export type JobStatusResponseState = (typeof JobStatusResponseState)[keyof typeof JobStatusResponseState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobStatusResponseState = {
  available: 'available',
  executing: 'executing',
  completed: 'completed',
  retryable: 'retryable',
  discarded: 'discarded',
  cancelled: 'cancelled',
} as const;

export interface JobStatusResponse {
  /** @nullable */
  args?: JobStatusResponseArgs;
  attempt: number;
  /** @nullable */
  attemptedAt: string | null;
  attempts: number;
  /** @nullable */
  cancelledAt?: string | null;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  discardedAt?: string | null;
  errors: string[];
  id: number;
  insertedAt: string;
  queue: string;
  /** @nullable */
  scheduledAt: string | null;
  state: JobStatusResponseState;
  /** @nullable */
  worker?: string | null;
}

export type ProgramTwispResourceResultStatus =
  (typeof ProgramTwispResourceResultStatus)[keyof typeof ProgramTwispResourceResultStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProgramTwispResourceResultStatus = {
  created: 'created',
  already_present: 'already_present',
} as const;

export interface ProgramTwispResourceResult {
  id: string;
  status: ProgramTwispResourceResultStatus;
}

export type JobUpdateArgs = { [key: string]: unknown };

export type JobUpdateMeta = { [key: string]: unknown };

export type JobUpdateState = (typeof JobUpdateState)[keyof typeof JobUpdateState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobUpdateState = {
  available: 'available',
  executing: 'executing',
  retryable: 'retryable',
  scheduled: 'scheduled',
  completed: 'completed',
  cancelled: 'cancelled',
  discarded: 'discarded',
} as const;

export interface JobUpdate {
  args?: JobUpdateArgs;
  /** @minimum 0 */
  attempt?: number;
  /** @nullable */
  attemptedAt?: string | null;
  /** @nullable */
  cancelledAt?: string | null;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  discardedAt?: string | null;
  /** @minimum 0 */
  maxAttempts?: number;
  meta?: JobUpdateMeta;
  /** @minimum 0 */
  priority?: number;
  queue?: string;
  /** @nullable */
  scheduledAt?: string | null;
  state?: JobUpdateState;
  tags?: string[];
  worker?: string;
}

export type FeeActionAllOfKind = (typeof FeeActionAllOfKind)[keyof typeof FeeActionAllOfKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeeActionAllOfKind = {
  CARD_PURCHASE: 'CARD_PURCHASE',
  REPAYMENT: 'REPAYMENT',
  FEE: 'FEE',
  CLOSE_CYCLE: 'CLOSE_CYCLE',
  PROCESS_DUE_DATE: 'PROCESS_DUE_DATE',
  DRAWDOWN: 'DRAWDOWN',
  PROCESS_LATE_FEE: 'PROCESS_LATE_FEE',
  ACH_RETURN: 'ACH_RETURN',
} as const;

export type FeeActionAllOf = {
  date: string;
  kind: FeeActionAllOfKind;
};

export type FeeActionAllOfThree = {
  feeAmountCents: number;
  feeDescription?: string;
  feeType?: string;
};

export type FeeActionKind = (typeof FeeActionKind)[keyof typeof FeeActionKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeeActionKind = {
  FEE: 'FEE',
} as const;

export type FeeAction = FeeActionAllOf &
  FeeActionAllOfThree & {
    kind: FeeActionKind;
  };

/**
 * @summary Trigger a dev credit line disbursement
 */
export const useDisburseFundsHook = () => {
  const disburseFunds = useCustomClient<DisburseFundsResponse>();

  return useCallback(
    (disburseFundsRequest: BodyType<DisburseFundsRequest>, signal?: AbortSignal) => {
      return disburseFunds({
        url: `/scdev/disbursement`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: disburseFundsRequest,
        signal,
      });
    },
    [disburseFunds],
  );
};

export const useDisburseFundsMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDisburseFundsHook>>>,
    TError,
    { data: BodyType<DisburseFundsRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDisburseFundsHook>>>,
  TError,
  { data: BodyType<DisburseFundsRequest> },
  TContext
> => {
  const mutationKey = ['disburseFunds'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const disburseFunds = useDisburseFundsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDisburseFundsHook>>>,
    { data: BodyType<DisburseFundsRequest> }
  > = props => {
    const { data } = props ?? {};

    return disburseFunds(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisburseFundsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDisburseFundsHook>>>>;
export type DisburseFundsMutationBody = BodyType<DisburseFundsRequest>;
export type DisburseFundsMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Trigger a dev credit line disbursement
 */
export const useDisburseFunds = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useDisburseFundsHook>>>,
      TError,
      { data: BodyType<DisburseFundsRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDisburseFundsHook>>>,
  TError,
  { data: BodyType<DisburseFundsRequest> },
  TContext
> => {
  const mutationOptions = useDisburseFundsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List Oban jobs from the last 24 hours
 */
export const useListRecentJobsHook = () => {
  const listRecentJobs = useCustomClient<RecentJobsResponse>();

  return useCallback(
    (signal?: AbortSignal) => {
      return listRecentJobs({ url: `/scdev/jobs`, method: 'GET', signal });
    },
    [listRecentJobs],
  );
};

export const getListRecentJobsQueryKey = () => {
  return [`/scdev/jobs`] as const;
};

export const useListRecentJobsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRecentJobsQueryKey();

  const listRecentJobs = useListRecentJobsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>> = ({ signal }) =>
    listRecentJobs(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListRecentJobsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>>;
export type ListRecentJobsQueryError = ErrorType<ErrorResponse>;

export function useListRecentJobs<
  TData = Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListRecentJobs<
  TData = Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListRecentJobs<
  TData = Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Oban jobs from the last 24 hours
 */

export function useListRecentJobs<
  TData = Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListRecentJobsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useListRecentJobsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fetch internal Oban job status
 */
export const useDevJobStatusHook = () => {
  const devJobStatus = useCustomClient<JobStatusResponse>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return devJobStatus({ url: `/scdev/jobs/${id}`, method: 'GET', signal });
    },
    [devJobStatus],
  );
};

export const getDevJobStatusQueryKey = (id?: string) => {
  return [`/scdev/jobs/${id}`] as const;
};

export const useDevJobStatusQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDevJobStatusQueryKey(id);

  const devJobStatus = useDevJobStatusHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>> = ({ signal }) =>
    devJobStatus(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DevJobStatusQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>>;
export type DevJobStatusQueryError = ErrorType<ErrorResponse>;

export function useDevJobStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDevJobStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDevJobStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Fetch internal Oban job status
 */

export function useDevJobStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDevJobStatusHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useDevJobStatusQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update specific fields on an Oban job
 */
export const useUpdateJobHook = () => {
  const updateJob = useCustomClient<JobStatusResponse>();

  return useCallback(
    (id: string, updateJobRequest: BodyType<UpdateJobRequest>) => {
      return updateJob({
        url: `/scdev/jobs/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateJobRequest,
      });
    },
    [updateJob],
  );
};

export const useUpdateJobMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateJobHook>>>,
    TError,
    { id: string; data: BodyType<UpdateJobRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateJobHook>>>,
  TError,
  { id: string; data: BodyType<UpdateJobRequest> },
  TContext
> => {
  const mutationKey = ['updateJob'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const updateJob = useUpdateJobHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateJobHook>>>,
    { id: string; data: BodyType<UpdateJobRequest> }
  > = props => {
    const { id, data } = props ?? {};

    return updateJob(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateJobMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateJobHook>>>>;
export type UpdateJobMutationBody = BodyType<UpdateJobRequest>;
export type UpdateJobMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update specific fields on an Oban job
 */
export const useUpdateJob = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useUpdateJobHook>>>,
      TError,
      { id: string; data: BodyType<UpdateJobRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateJobHook>>>,
  TError,
  { id: string; data: BodyType<UpdateJobRequest> },
  TContext
> => {
  const mutationOptions = useUpdateJobMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Recreates missing program journal, exposure account set, and ISO configuration from their persisted IDs.
 * @summary Restore a program's Twisp configuration
 */
export const useRestoreProgramTwispHook = () => {
  const restoreProgramTwisp = useCustomClient<ProgramTwispRestoreResponse>();

  return useCallback(
    (programId: string, signal?: AbortSignal) => {
      return restoreProgramTwisp({ url: `/scdev/programs/${programId}/twisp/restore`, method: 'POST', signal });
    },
    [restoreProgramTwisp],
  );
};

export const useRestoreProgramTwispMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRestoreProgramTwispHook>>>,
    TError,
    { programId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRestoreProgramTwispHook>>>,
  TError,
  { programId: string },
  TContext
> => {
  const mutationKey = ['restoreProgramTwisp'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const restoreProgramTwisp = useRestoreProgramTwispHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRestoreProgramTwispHook>>>,
    { programId: string }
  > = props => {
    const { programId } = props ?? {};

    return restoreProgramTwisp(programId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreProgramTwispMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRestoreProgramTwispHook>>>
>;

export type RestoreProgramTwispMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Restore a program's Twisp configuration
 */
export const useRestoreProgramTwisp = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useRestoreProgramTwispHook>>>,
      TError,
      { programId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRestoreProgramTwispHook>>>,
  TError,
  { programId: string },
  TContext
> => {
  const mutationOptions = useRestoreProgramTwispMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Trigger a dev ACH payment to settle a statement
 */
export const usePayStatementHook = () => {
  const payStatement = useCustomClient<PayStatementResponse>();

  return useCallback(
    (payStatementRequest: BodyType<PayStatementRequest>, signal?: AbortSignal) => {
      return payStatement({
        url: `/scdev/statements/pay`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: payStatementRequest,
        signal,
      });
    },
    [payStatement],
  );
};

export const usePayStatementMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePayStatementHook>>>,
    TError,
    { data: BodyType<PayStatementRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePayStatementHook>>>,
  TError,
  { data: BodyType<PayStatementRequest> },
  TContext
> => {
  const mutationKey = ['payStatement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const payStatement = usePayStatementHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePayStatementHook>>>,
    { data: BodyType<PayStatementRequest> }
  > = props => {
    const { data } = props ?? {};

    return payStatement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayStatementMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePayStatementHook>>>>;
export type PayStatementMutationBody = BodyType<PayStatementRequest>;
export type PayStatementMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Trigger a dev ACH payment to settle a statement
 */
export const usePayStatement = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof usePayStatementHook>>>,
      TError,
      { data: BodyType<PayStatementRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePayStatementHook>>>,
  TError,
  { data: BodyType<PayStatementRequest> },
  TContext
> => {
  const mutationOptions = usePayStatementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Enqueues an Oban job for the provided timeline actions.
 * @summary Queue a Twisp timeline for execution
 */
export const useRunTwispTimelineHook = () => {
  const runTwispTimeline = useCustomClient<RunTimelineResponse>();

  return useCallback(
    (runTimelineRequest: BodyType<RunTimelineRequest>, signal?: AbortSignal) => {
      return runTwispTimeline({
        url: `/scdev/timeline/run`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: runTimelineRequest,
        signal,
      });
    },
    [runTwispTimeline],
  );
};

export const useRunTwispTimelineMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRunTwispTimelineHook>>>,
    TError,
    { data: BodyType<RunTimelineRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRunTwispTimelineHook>>>,
  TError,
  { data: BodyType<RunTimelineRequest> },
  TContext
> => {
  const mutationKey = ['runTwispTimeline'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const runTwispTimeline = useRunTwispTimelineHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRunTwispTimelineHook>>>,
    { data: BodyType<RunTimelineRequest> }
  > = props => {
    const { data } = props ?? {};

    return runTwispTimeline(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunTwispTimelineMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRunTwispTimelineHook>>>
>;
export type RunTwispTimelineMutationBody = BodyType<RunTimelineRequest>;
export type RunTwispTimelineMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Queue a Twisp timeline for execution
 */
export const useRunTwispTimeline = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useRunTwispTimelineHook>>>,
      TError,
      { data: BodyType<RunTimelineRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRunTwispTimelineHook>>>,
  TError,
  { data: BodyType<RunTimelineRequest> },
  TContext
> => {
  const mutationOptions = useRunTwispTimelineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Post a synthetic card transaction to Twisp
 */
export const useAddCardTransactionHook = () => {
  const addCardTransaction = useCustomClient<AddCardTransactionResponse>();

  return useCallback(
    (addCardTransactionRequest: BodyType<AddCardTransactionRequest>, signal?: AbortSignal) => {
      return addCardTransaction({
        url: `/scdev/transactions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addCardTransactionRequest,
        signal,
      });
    },
    [addCardTransaction],
  );
};

export const useAddCardTransactionMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddCardTransactionHook>>>,
    TError,
    { data: BodyType<AddCardTransactionRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAddCardTransactionHook>>>,
  TError,
  { data: BodyType<AddCardTransactionRequest> },
  TContext
> => {
  const mutationKey = ['addCardTransaction'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const addCardTransaction = useAddCardTransactionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAddCardTransactionHook>>>,
    { data: BodyType<AddCardTransactionRequest> }
  > = props => {
    const { data } = props ?? {};

    return addCardTransaction(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddCardTransactionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAddCardTransactionHook>>>
>;
export type AddCardTransactionMutationBody = BodyType<AddCardTransactionRequest>;
export type AddCardTransactionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Post a synthetic card transaction to Twisp
 */
export const useAddCardTransaction = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAddCardTransactionHook>>>,
      TError,
      { data: BodyType<AddCardTransactionRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAddCardTransactionHook>>>,
  TError,
  { data: BodyType<AddCardTransactionRequest> },
  TContext
> => {
  const mutationOptions = useAddCardTransactionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Initialize Twisp ledger objects for a user
 */
export const useInitializeTwispForUserHook = () => {
  const initializeTwispForUser = useCustomClient<InitializeTwispUserResponse>();

  return useCallback(
    (initializeTwispUserRequest: BodyType<InitializeTwispUserRequest>, signal?: AbortSignal) => {
      return initializeTwispForUser({
        url: `/scdev/twisp/init_user`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: initializeTwispUserRequest,
        signal,
      });
    },
    [initializeTwispForUser],
  );
};

export const useInitializeTwispForUserMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInitializeTwispForUserHook>>>,
    TError,
    { data: BodyType<InitializeTwispUserRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useInitializeTwispForUserHook>>>,
  TError,
  { data: BodyType<InitializeTwispUserRequest> },
  TContext
> => {
  const mutationKey = ['initializeTwispForUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const initializeTwispForUser = useInitializeTwispForUserHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useInitializeTwispForUserHook>>>,
    { data: BodyType<InitializeTwispUserRequest> }
  > = props => {
    const { data } = props ?? {};

    return initializeTwispForUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type InitializeTwispForUserMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useInitializeTwispForUserHook>>>
>;
export type InitializeTwispForUserMutationBody = BodyType<InitializeTwispUserRequest>;
export type InitializeTwispForUserMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Initialize Twisp ledger objects for a user
 */
export const useInitializeTwispForUser = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useInitializeTwispForUserHook>>>,
      TError,
      { data: BodyType<InitializeTwispUserRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useInitializeTwispForUserHook>>>,
  TError,
  { data: BodyType<InitializeTwispUserRequest> },
  TContext
> => {
  const mutationOptions = useInitializeTwispForUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
